import {Button, Col, Row} from "reactstrap";
import {ChangeDateFormat} from "../../Helpers/ChangeDateFormat";
import React from "react";
import {useTranslation} from "react-i18next";
import {CheckUserPermission} from "../../../AppSystem/Helpers/CheckUserPermission";

export const UserProfileHeader = ({ data, minimal = false, isSuperAdmin = null, type = null, handleClickTrash = null, handleClickActive = null ,page = null, inFlow = false}) => {
    const { t } = useTranslation();

    let permissionDelete = false;
    if (CheckUserPermission("user.delete") || CheckUserPermission("user")) {
        permissionDelete = true;
    }

    let permissionActive = false;
    if (CheckUserPermission("user.active") || CheckUserPermission("user")) {
        permissionActive = true;
    }

    const profileTextContent = (
        <Col lg="12" className="p-2 ps-3 ps-lg-5 pe-3">
            <h3 className=" text-white mb-3">{data.firstName} {data.lastName}</h3>

            {/* 🔹 Solo muestra los detalles si minimal es false */}
            {!minimal && (
                <Row className="d-flex flex-wrap align-items-start text-white-50 g-2">
                    {isSuperAdmin && isSuperAdmin === true ?
                        <Col lg="auto" className="me-3 mb-1 text-break">
                            <i className="bx bx-user me-1 text-white-75 fs-16 align-middle pe-2" />
                            {data.id}
                        </Col>
                    : ''}
                    {data.visualId !== "" ?
                        <Col lg="auto" className="me-3 mb-1 text-break">
                            <i className="bx bx-hash me-1 text-white-75 fs-16 align-middle pe-2" />
                            {data.visualId}
                        </Col>
                    : ""}
                    <Col lg="auto" className="me-3 mb-1 text-break">
                        <i className="bx bx-map-pin me-1 text-white-75 fs-16 align-middle pe-2" />
                        {t('modelLabel.sweden')}
                    </Col>
                    {!page && (
                        <Col lg="auto" className="me-3 mb-1 text-break">
                            <i className="bx bx-id-card me-1 text-white-75 fs-16 align-middle pe-2" />
                            {data.pnr}
                        </Col>
                    )}
                    <Col lg="auto" className="me-3 mb-1 text-break">
                        <i className="bx bx-envelope me-1 text-white-75 fs-16 align-middle pe-2" />
                        {data.email}
                    </Col>
                    {data.phone && data.phone !== "" ?
                        <Col lg="auto" className="me-3 mb-1 text-break">
                            <i className="bx bx-phone me-1 text-white-75 fs-16 align-middle pe-2" />
                            {data.phone}
                        </Col>
                    : ""}
                    {data.loggedOnLastTime && data.loggedOnLastTime !== "" ?
                        <Col lg="auto" className="me-3 mb-1 text-break">
                            <i className="bx bx-time-five me-1 text-white-75 fs-16 align-middle pe-2" />
                            {ChangeDateFormat('dateTime', data.loggedOnLastTime)}
                        </Col>
                    : ''}
                </Row>
            )}
        </Col>
    );

    return (
        <div className={`position-relative ${inFlow ? 'profile-header-flow' : ''}`}>
            <div className="profile-wid-bg z-0"></div>
                {/*type != null && type === "Admin" && handleClickTrash != null && (!data.status || (data.status && data.status !== "Raderad")) && permissionDelete === true ?
                    <div className="position-absolute end-0 top-0">
                        {<Button className="ms-3 box-red border-0 position-relative rounded mt-3 me-3" onClick={handleClickTrash}>
                            <i className="bx bx-trash align-middle pb-1"/>
                            <div className="tooltip-custom-button">
                                {t("button.delete")}
                            </div>
                        </Button>}
                    </div>
                : ""*/}
                {/*type != null && type === "Admin" && handleClickActive != null && data.status && data.status === "Raderad" && permissionActive === true ?
                    <div className="position-absolute end-0 top-0">
                        {<Button className="ms-3 box-green border-0 position-relative rounded mt-3 me-3" onClick={handleClickActive}>
                            <i className="bx bx-user-check align-middle pb-1"/>
                            <div className="tooltip-custom-button">
                                {t("button.active")}
                            </div>
                        </Button>}
                    </div>
                : ""*/}

            <div className={`pt-4 position-absolute top-0 start-0 w-100 z-3 mx-0 row ${inFlow ? 'profile-header-row-flow' : ''}`}>
                {profileTextContent}
            </div>
        </div>
    )
}